// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"868":"bc7d6d61ea4d525b","915":"61b1afca5db6ce63"}[chunkId] + ".js";
};